(function(){
  'use strict';
  function buildState(total,cookbookGoal,shippingGoal,currency){
    const subtotal=Math.max(0,Number(total));
    if(!Number.isFinite(subtotal))return null;
    const money=n=>new Intl.NumberFormat(undefined,{style:'currency',currency}).format(n/100);
    const cookbook=subtotal>=cookbookGoal;
    const shipping=subtotal>=shippingGoal;
    let message;
    if(cookbook&&shipping){
      message="Congratulations! You've unlocked your free cookbook and free shipping!";
    }else if(cookbook){
      message="Free cookbook unlocked! You're "+money(shippingGoal-subtotal)+" away from free shipping!";
    }else{
      message="You're "+money(cookbookGoal-subtotal)+" away from a free cookbook!";
    }
    return {message,cookbook,shipping,percent:Math.min(100,subtotal/shippingGoal*100),cookbookLabel:money(cookbookGoal)+': Free cookbook',shippingLabel:money(shippingGoal)+': Free shipping'};
  }
  const script=document.querySelector('script[data-baf-native-milestones]');
  if(!script)return;
  const cookbookGoal=Number(script.dataset.cookbook);
  const shippingGoal=Number(script.dataset.shipping);
  const currency=script.dataset.currency||'USD';
  const booster=script.dataset.booster;
  if(!booster||!Number.isFinite(cookbookGoal)||!Number.isFinite(shippingGoal)||cookbookGoal<=0||shippingGoal<=cookbookGoal)return;
  if(window.Shopify?.currency?.active&&window.Shopify.currency.active!==currency)return;
  const root=script.dataset.root.replace(/\/?$/,'/');
  const selector='[class~="free_shipping_card_wrapper_'+booster+'"]';
  let cart=null,timer,version=0;
  function render(){
    if(!cart)return;
    const state=buildState(cart.total_price,cookbookGoal,shippingGoal,currency);
    if(!state)return;
    document.querySelectorAll(selector).forEach(bar=>{
      const title=bar.querySelector('[class~="free_shipping_card_title_'+booster+'"]');
      const rail=bar.querySelector('[class~="free_shipping_card_progress_'+booster+'"]');
      const fill=bar.querySelector('[class~="free_shipping_card_progress_bar_'+booster+'"]');
      if(!title||!rail||!fill)return;
      if(title.textContent!==state.message)title.textContent=state.message;
      title.setAttribute('aria-live','polite');
      title.setAttribute('aria-atomic','true');
      const width=state.percent+'%';
      if(fill.style.width!==width)fill.style.width=width;
      rail.setAttribute('data-baf-native-progress','');
      rail.setAttribute('role','progressbar');
      rail.setAttribute('aria-label','Cookbook and shipping progress after discounts');
      rail.setAttribute('aria-valuemin','0');
      rail.setAttribute('aria-valuemax',String(shippingGoal/100));
      rail.setAttribute('aria-valuenow',String(Math.min(shippingGoal,Math.max(0,Number(cart.total_price)))/100));
      rail.style.setProperty('--baf-native-cookbook-position',cookbookGoal/shippingGoal*100+'%');
      let labels=bar.querySelector('[data-baf-native-labels]');
      if(!labels){
        labels=document.createElement('div');
        labels.className='baf-native-milestones';
        labels.setAttribute('data-baf-native-labels','');
        const book=document.createElement('span');
        book.setAttribute('data-baf-native-cookbook','');
        const shipping=document.createElement('span');
        shipping.setAttribute('data-baf-native-shipping','');
        labels.append(book,shipping);
        rail.insertAdjacentElement('afterend',labels);
      }
      const bookLabel=labels.querySelector('[data-baf-native-cookbook]');
      const shipLabel=labels.querySelector('[data-baf-native-shipping]');
      if(bookLabel.textContent!==state.cookbookLabel)bookLabel.textContent=state.cookbookLabel;
      if(shipLabel.textContent!==state.shippingLabel)shipLabel.textContent=state.shippingLabel;
      bookLabel.classList.toggle('is-unlocked',state.cookbook);
      shipLabel.classList.toggle('is-unlocked',state.shipping);
      let note=bar.querySelector('[data-baf-native-note]');
      if(!note){
        note=document.createElement('small');
        note.className='baf-native-milestones__note';
        note.setAttribute('data-baf-native-note','');
        note.textContent='After discounts, before taxes and shipping.';
        labels.insertAdjacentElement('afterend',note);
      }
    });
  }
  async function refresh(){
    const current=++version;
    try{
      const response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Cart read failed');
      const next=await response.json();
      if(current!==version)return;
      cart=next;
      render();
    }catch(error){
      console.warn('B.A.F. native milestone refresh:',error.message);
    }
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(refresh,200);}
  ['ajaxProduct:added','cart:updated','cart:build','cart:change','cart:add','drawerOpen','baf:rewards-updated'].forEach(name=>document.addEventListener(name,schedule));
  document.addEventListener('change',event=>{if(event.target.closest('#CartDrawer,#CartPageForm'))schedule();});
  document.addEventListener('click',event=>{
    if(event.target.closest('[class*="free_shipping_card_product_cta_"],#CartDrawer button,#CartPageForm button,[data-cart-drawer]'))schedule();
  });
  const observer=new MutationObserver(records=>{
    let refreshNeeded=false;
    const state=cart&&buildState(cart.total_price,cookbookGoal,shippingGoal,currency);
    records.forEach(record=>{
      const target=record.target.nodeType===1?record.target:record.target.parentElement;
      if(!target)return;
      if(target.closest('#CartDrawer [data-products],#CartPageForm [data-products],[data-subtotal]'))refreshNeeded=true;
      const title=target.closest('[class~="free_shipping_card_title_'+booster+'"]');
      if(title&&state&&title.textContent!==state.message)refreshNeeded=true;
    });
    render();
    if(refreshNeeded)schedule();
  });
  observer.observe(document.body,{childList:true,subtree:true,characterData:true});
  window.addEventListener('pageshow',schedule);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
  refresh();
})();
